var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHtml = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 22,
    viewBox: "0 0 37 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16833 3.5C2.39431 3.5 0.973684 4.94367 0.973684 6.70259V15.2974C0.973684 17.0563 2.39431 18.5 4.16833 18.5H32.8317C34.6057 18.5 36.0263 17.0563 36.0263 15.2974V6.70259C36.0263 4.94368 34.6057 3.5 32.8317 3.5H4.16833ZM0 6.70259C0 4.37174 1.87589 2.5 4.16833 2.5H32.8317C35.1241 2.5 37 4.37174 37 6.70259V15.2974C37 17.6283 35.1241 19.5 32.8317 19.5H4.16833C1.87589 19.5 0 17.6283 0 15.2974V6.70259Z",
    fill: "#00C650"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6313 7.5V13.9936H10.0453V11.2834H7.57528V13.9936H6.0001V7.5H7.57528V10.0158H10.0453V7.5H11.6313Z",
    fill: "#00C650"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3989 8.74818V7.5H12.3029V8.74818H14.0536V13.9936H15.6309V8.74818H17.3989Z",
    fill: "#00C650"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3898 7.5453V13.9935H23.8037V9.96824L22.4041 14H21.0391L19.6307 9.9596V14H18.0534V7.55178H19.9796L21.7411 12.0435L23.4636 7.55178L25.3898 7.5453Z",
    fill: "#00C650"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1542 12.7907H28.0525L28.0482 7.5H26.4708V13.9936H30.1542V12.7907Z",
    fill: "#00C650"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHtml);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/html.8603b1688c0bbe1de3b0be546ff053e7.svg";